<app-popup [isVisible]="true">
  <h4 header>
    <span class="font-weight-normal">
      {{
        'refund.modal.success_first_line'
          | translate
            : {
                plural_text:
                  'pluralMapper.someOfAllTicket'
                  | translateSelector : { some: content.successContent?.refundedItemsCount, all: content.successContent?.allItemsCount }
              }
      }}</span>
  </h4>

  <div class="row">
    <div class="col-12">
      <div class="question">
        <span class="font-weight-normal">{{ 'refund.modal.success_second_line' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="row" footer>
    <div class="col-12 text-center d-flex justify-content-center gap-2 flex-wrap">
      <button type="button" class="btn btn-next" (click)="close(true)">
        {{ 'refund.modal.button.back' | translate }}
      </button>
      <button type="button" class="btn btn-next" (click)="close()">
        {{ 'refund.modal.button.another_refund' | translate }}
      </button>
    </div>
  </div>
</app-popup>